import React, { useMemo } from 'react';

import { useGetTopMaintainersQuery } from '../../redux/apis/analyticsManagement/aMAnalyticsApiSlice';
import BarChart from '../other/charts/BarChart';
import ComponentLoader from '../other/ComponentLoader';
import { pickTopCounts } from './iptvReportedBarHelpers';

const TOP_ISPS_LIMIT = 5;
const CHART_HEIGHT = '380px';

const IPTVTopReportedIsps = ({ chartThemeKey = 0 }) => {
  const { data: topMaintainersData, isLoading, isError, error } = useGetTopMaintainersQuery();

  const ispsBarData = useMemo(
    () => Object.fromEntries(pickTopCounts(topMaintainersData, TOP_ISPS_LIMIT)),
    [topMaintainersData]
  );

  const hasIspRows = Object.keys(ispsBarData).length > 0;
  const errorMessage = error?.data?.message;

  return (
    <div className='relative'>
      {isLoading ? <ComponentLoader /> : null}
      {isError ? (
        <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75 z-1'>
          Failed to load.
          {errorMessage ? ` ${errorMessage}` : ''}
        </div>
      ) : null}

      <p className='text-center font-medium mb-2'>Top 5 Reported ISPs</p>
      {!isLoading && !isError && !hasIspRows ? (
        <p className='text-center small text-inverse text-opacity-50'>No ISP data.</p>
      ) : !isLoading && !isError ? (
        <BarChart key={`isps-${chartThemeKey}`} data={ispsBarData} height={CHART_HEIGHT} />
      ) : null}
    </div>
  );
};

export default IPTVTopReportedIsps;
